import { NavLink } from 'react-router-dom';

import { NAV_ITEMS } from './nav-items.js';

export function BottomTabs(): JSX.Element {
  return (
    <nav
      className="fixed bottom-3 left-1/2 z-30 flex w-[calc(100%-1.5rem)] max-w-md -translate-x-1/2 items-stretch gap-1 rounded-full bg-paper/95 p-1.5 shadow-lg shadow-brown/15 backdrop-blur lg:hidden"
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
    >
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center justify-center gap-0.5 rounded-full px-2 py-2 text-[10px] font-semibold transition-colors ${
              isActive
                ? 'bg-cream-dark text-terracotta-dark'
                : 'text-brown-light hover:text-brown'
            }`
          }
        >
          <span className="text-lg leading-none" aria-hidden>
            {item.icon}
          </span>
          <span className="leading-none">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
